import { render, staticRenderFns } from "./users.vue?vue&type=template&id=4f0ab27e&"
import script from "./users.vue?vue&type=script&lang=js&"
export * from "./users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0ab27e')) {
      api.createRecord('4f0ab27e', component.options)
    } else {
      api.reload('4f0ab27e', component.options)
    }
    module.hot.accept("./users.vue?vue&type=template&id=4f0ab27e&", function () {
      api.rerender('4f0ab27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/users.vue"
export default component.exports